import { render, staticRenderFns } from "./BaseballCover_c2.vue?vue&type=template&id=5d72d3a4&"
import script from "./BaseballCover_c2.vue?vue&type=script&lang=js&"
export * from "./BaseballCover_c2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports